export var ChartType;
(function (ChartType) {
    ChartType[ChartType["CMOD"] = 2] = "CMOD";
    ChartType[ChartType["XMOD"] = 4] = "XMOD";
    ChartType[ChartType["SV"] = 8] = "SV";
})(ChartType || (ChartType = {}));
export default class ChartBase {
    constructor(data) {
        this._validTypes = 0;
        this.charts = [];
        this.parse(data);
    }
    get validTypes() {
        return this._validTypes;
    }
    parse(data) {
    }
    sortTimeline(events) {
        events.sort(this.sortTimelineCompare);
    }
    sortTimelineCompare(a, b) {
        if (a.BEAT != b.BEAT)
            return a.BEAT - b.BEAT;
        if (a.PRIORITY != b.PRIORITY)
            return a.PRIORITY - b.PRIORITY;
        if (a.INDEX != b.INDEX)
            return a.INDEX - b.INDEX;
        return 0;
    }
}
